import { useEffect, useState } from 'react';

import { useUserStore } from '../../../../modules/Auth/stores/authStore';
import { Button } from '../../atoms/Button';
import { Icon } from '../../atoms/Icon';
import DropDown from '../Dropdown';
import { Typography } from '../Typography';

export interface IDropDownItems {
  id: string;
  title: string;
  subtitle?: string;
  disabled?: boolean;
}

export interface IDropDownListProps {
  size?: 'regular' | 'compact' | 'small';
  items: IDropDownItems[];
  value?: IDropDownItems | null;
  onSelect: (item: IDropDownItems) => void;
  disabled?: boolean;
  noPadding?: boolean;
}

export function DropDownList({
  size = 'regular',
  items,
  value,
  onSelect,
  disabled = false,
  noPadding = false,
}: IDropDownListProps) {
  const { user } = useUserStore();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<
    IDropDownItems | null | undefined
  >(value);

  function handleSelect(item: IDropDownItems) {
    setSelectedItem(item);
    onSelect(item);
    setIsOpen(false);
  }

  useEffect(() => {
    setSelectedItem(value);
  }, [value]);

  const getSize = () => {
    if (size === 'small') return 'md:text-h3';
    if (size === 'compact') return 'md:text-h5';
    return 'md:text-h2';
  }

  return (
    <>
      <div className='flex w-fit flex-row items-center'>
        <Button
          allowReadOnly
          size='regular'
          variant='text'
          className={`text-black px-0 ${noPadding ? 'pl-0' : 'pl-4'}`}
          onClick={() => setIsOpen(!isOpen)}
          data-tooltip-id={`week-select`}
          disabled={disabled}
        >
          <Typography
            type='title'
            className={`xs:text-h4 ${getSize()} `}
          >
            {selectedItem ? selectedItem.title : 'Selecione'}
          </Typography>
          {isOpen ? (
            <Icon
              Icon='expand_less'
              type='material'
              className='text-mono-color-black'
            />
          ) : (
            <Icon
              Icon='expand_more'
              type='material'
              className='text-mono-color-black'
            />
          )}
        </Button>
      </div>
      <DropDown
        id={`week-select`}
        position='bottom-start'
        arrow
        onClick
        afterHide={(status) => setIsOpen(status)}
        isOpen={isOpen}
        style={{
          backgroundColor: user?.isDarkMode ? '#000C29' : '#ffffff',
          zIndex: 999,
        }}
      >
        <div className='max-h-[45vh] overflow-y-auto'>
          {items.map((item, index) => (
            <Button
              allowReadOnly
              key={index}
              id={
                selectedItem && item.id === selectedItem.id
                  ? 'selectedWeek'
                  : ''
              }
              variant={
                selectedItem && item.id === selectedItem.id
                  ? 'selected'
                  : 'hoverable'
              }
              full='menu'
              onClick={() => {
                handleSelect(item);
              }}
              disabled={item.disabled}
              className='w-full'
            >
              <div className='flex w-full flex-row items-center justify-between gap-xl'>
                <Typography
                  type={size === 'compact' ? 'p' : 'lead'}
                  weight='bold'
                >
                  {item.title}
                </Typography>

                <Typography size='small' variant='italic'>
                  {item.subtitle}
                </Typography>
              </div>
            </Button>
          ))}
        </div>
      </DropDown>
    </>
  );
}
